'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIZE_CLASSES = exports.SIZE_CLASSES = {
  'default': 'private-button--default',
  'small': 'private-button--sm btn-sm',
  'extra-small': 'private-button--xs'
};

var USE_CLASSES = exports.USE_CLASSES = {
  'danger': 'private-button--destructive btn-danger',
  'link': 'private-button__link btn-link',
  'link-danger': 'private-button__link private-button__link--danger',
  'link-on-dark': 'private-button__link private-button__link--on-dark btn-link',
  'primary': 'private-button--primary btn-primary',
  'secondary': 'private-button--secondary btn-default',
  'tertiary': 'private-button--tertiary btn-info',
  'tertiary-light': 'private-button--tertiary-light btn-info',
  'transparent': 'private-button--transparent',
  'unstyled': 'private-button--unstyled',
  'form': 'private-button--form private-form__control'
};

var LINK_USES = exports.LINK_USES = ['link', 'link-danger', 'link-on-dark'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/button/ButtonConstants.js
// module id = 229
// module chunks = 0 1